import styled from 'styled-components'

import { ClientCardUnstyled } from 'Components/Clients/ClientCard/unstyled'

export const ClientCard = styled(ClientCardUnstyled)`
  position: relative;
  display: block;
  width: 100%;

  .card {
    position: relative;
    border: 1px solid ${props => props.theme.colors.iron};
    border-radius: 4px;
    background: ${props => props.theme.colors.white};
    padding: 18px;
    margin: 0;
    cursor: pointer;

    .client-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: ${props => props.theme.fontSizes.clients.card.name};
      color: ${props => props.theme.colors.oxfordBlue};
      margin: 0 0 20px 0;

      img {
        width: 44px;
        height: 44px;
        display: inline-block;
        border-radius: 50%;
        border: 1px solid #000;
        margin: 0 10px 0 0;
      }
    }

    a {
      position: relative;
      display: inline-block;
      height: 15px;
      line-height: 16px;
      font-size: ${props => props.theme.fontSizes.clients.card.link};
      color: ${props => props.theme.colors.regentGray};
      padding: 0 0 0 24px;
      margin: 0 20px 0 0;

      svg {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 18px;
      }

      &.edit {
        svg {
          fill: ${props => props.theme.colors.regentGray};
        }
      }

      &.view {
        svg {
          fill: ${props => props.theme.colors.primary};
        }
      }

      &:hover {
        text-decoration: none;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Clients/ClientCard/index.js